import styled, { css } from "styled-components"
import { transparentize } from "polished"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const selectedStyle = css`
  display: block;
  height: 100%;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.primary};
  position: relative;
  overflow: hidden;
`

export const Selected = styled.span`
  display: none;

  ${({ selected }) => selected && selectedStyle}
`

export const Container = styled.div`
  cursor: pointer;
  width: 100%;

  &:hover {
    ${Selected} {
      ${selectedStyle}
    }
  }

  ${({ compact }) => css`
    ${compact &&
    css`
      width: auto;
    `}
  `}
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem;
  text-align: center;

  ${({ compact }) => css`
    ${compact &&
    css`
      padding: 0.5rem;
    `}
  `}

  ${({ profile }) =>
    !!profile &&
    css`
      text-align: left;
      justify-content: start;
      padding: 0;
      gap: 16px;
      align-items: stretch;
    `}
`

export const Icon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.primary};

  ${({ compact, selected }) => css`
    ${compact &&
    css`
      color: #dddddd;
    `}

    ${compact &&
    selected &&
    css`
      color: ${({ theme }) => theme.colors.primary};
    `}
  `}
`

export const Name = styled.div`
  color: ${({ theme }) => theme.colors.nav?.name || theme.colors.secondary};
  font-weight: 700;
  white-space: nowrap;
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;

  ${({ compact, selected }) => css`
    ${compact &&
    css`
      font-size: 1.25rem;
      color: #aaaaaa;
    `}

    ${compact &&
    selected &&
    css`
      color: ${({ theme }) => theme.colors.nav?.name || theme.colors.secondary};
    `}
  `}

  ${({ profile }) =>
    !!profile &&
    css`
      font-weight: 500;
      white-space: pre-line;
      line-height: 1.45em;
      font-size: 18px;
      color: #777777;
      max-width: 190px;

      &:hover {
        color: ${({ theme }) => theme.colors.secondaryAlternative || theme.colors.secondary};
      }
    `}

    ${({ profile, selected }) =>
    !!profile &&
    !!selected &&
    css`
      color: ${({ theme }) => theme.colors.secondaryAlternative || theme.colors.secondary};
    `}
`

export const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  font-size: 0.75rem;
  font-weight: bold;
  padding: 0.15rem 0.5rem;
  border-radius: 5px;

  ${({ compact }) => css`
    ${compact &&
    css`
      padding: 0.25rem 0.5rem;
    `}
  `}
`

export const Bar = styled.div`
  width: 100%;
  height: 0.5rem;
  background-color: ${({ theme }) => transparentize(0.6, theme.colors.primary)};
  position: relative;

  ${({ transparent }) => css`
    ${transparent &&
    css`
      background-color: transparent;
      height: 4px;
    `}
  `}

  ${({ first, last }) => css`
    ${first &&
    css`
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    `}

    ${last &&
    css`
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    `}
  `}
`

export const ProfileSelected = styled.div`
  ${({ selected }) =>
    !!selected &&
    css`
      border: 2px solid ${({ theme }) => theme.colors.primary};
      border-radius: 4px;
    `}
  ${({ selected }) =>
    !selected &&
    css`
      width: 4px;
    `}
`
